import { type FC } from 'react';
import {
    ClickableIcon,
    type ClickableIconProps,
    type ColorlessIconProps,
    IconVerticalMenu,
    Menu,
    type MenuProps,
    type TestProps,
} from '@direct-frontend/components';

export type VerticalMenuProps = TestProps & {
    size?: MenuProps<string, string>['size'];
    items?: MenuProps<string, string>['items'];
    placement?: MenuProps<string, string>['placement'];
    isDisabled?: boolean;
    menuProps?: Omit<MenuProps<string, string>, 'size' | 'placement' | 'items'>;
    triggerProps?: Omit<ClickableIconProps, 'children'>;
    iconProps?: ColorlessIconProps;
    className?: MenuProps<string, string>['className'];
};

export const VerticalMenu: FC<VerticalMenuProps> = ({
    'data-testid': dataTestId = 'VerticalMenu',
    size = 'm',
    items = [],
    placement = ['bottom-end', 'top-end'],
    isDisabled = false,
    menuProps = {},
    triggerProps = {},
    iconProps = {},
    className,
}) => (
    <Menu
        {...menuProps}
        data-testid={`${dataTestId}.Kebab`}
        aria-label="Контекстное меню"
        size={size}
        items={items}
        placement={placement}
        className={className}
        trigger={
            <ClickableIcon
                {...triggerProps}
                data-testid={`${dataTestId}.Kebab.OpenButton`}
                role="supplementary"
                isDisabled={isDisabled || items.length === 0}
            >
                <IconVerticalMenu size="20" {...iconProps} />
            </ClickableIcon>
        }
    />
);
